import { AddOutlined, triggerToast } from "@qivia/ui";
import { t } from "i18next";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateDepartmentModal } from "./modals/createDepartmentModal";
import { SharedInterfaceDepartments } from "./sharedInterface";
import { DepartmentSidePanel } from "./sidePanel/SidePanel";
import { SidePanelDepartmentTypeDisplayed } from "./departmentsApi";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCreateDepartmentOfCompanyStatus, departmentsSlice } from "./departmentsSlice";
import { selectCompany } from "../homeSlice";
import { selectVehicleDepartmentUpdatedStatus, vehiclesSlice } from "../vehicles/vehiclesSlice";

export const Departments = () => {
  const env = import.meta.env["VITE_TARGET_ENV"] as string;
  const dispatch = useAppDispatch();
  const firstPath = location.pathname.split("/")[1]; 
  const navigate = useNavigate();
  const company = useAppSelector(selectCompany)
  const createDepartmentOfCompanyStatus = useAppSelector(selectCreateDepartmentOfCompanyStatus);

  const [isCreateDepartmentModalVisible, setIsCreateDepartmentModalVisible] = useState(false);
  const vehicleDepartmentUpdatedStatus = useAppSelector(selectVehicleDepartmentUpdatedStatus);

  useEffect(() => {
    if (env === "production") {
      navigate("/home");
    }
  }, [env, navigate]);

  const sidePanelAction = useCallback(
    (props: Partial<SidePanelDepartmentTypeDisplayed>) => {
      navigate(`/${firstPath}/departments/${props.id}`);
    },
    [firstPath, navigate],
  );

  useEffect(() => {
    if (company && createDepartmentOfCompanyStatus === "success") {
      triggerToast(t("departments.modal.success"), "valid");
      void dispatch(departmentsSlice.actions.resetDepartmentsListStatus());
      setIsCreateDepartmentModalVisible(false);
    } else if (createDepartmentOfCompanyStatus === "failed") {
      triggerToast(t("departments.modal.failure"), "error");
      void dispatch(departmentsSlice.actions.resetDepartmentsListStatus());
    }
  }, [company, createDepartmentOfCompanyStatus, dispatch])

  useEffect(() => {
    if (company && vehicleDepartmentUpdatedStatus === "success") {
      triggerToast(t("departments.addVehicleModal.success"), "valid");
      void dispatch(vehiclesSlice.actions.resetVehicleUpdatedDepartmentStatus());
      setIsCreateDepartmentModalVisible(false);
    } else if (vehicleDepartmentUpdatedStatus === "failed") {
      triggerToast(t("departments.addVehicleModal.failure"), "error");
      void dispatch(vehiclesSlice.actions.resetVehicleUpdatedDepartmentStatus());
    }
  }, [company, vehicleDepartmentUpdatedStatus, dispatch])

  const cta = {
    title: t("departments.cta"),
    action: () => {
      setIsCreateDepartmentModalVisible(true)
    },
    width: 12,
    leftIcon: <AddOutlined />,
  };

  return (
    <>
      <CreateDepartmentModal
        visible={isCreateDepartmentModalVisible}
        onCloseModal={() => {
          setIsCreateDepartmentModalVisible(false);
        }}
      />
      <SharedInterfaceDepartments 
        cta={cta}
        sidePanelAction={sidePanelAction}
        sidePanel={
          <DepartmentSidePanel
            canAddVehicle
            canDeactivate        
          />
        }
      />
    </>
  );
};
